import React from "react";

export default function BookService() {
  return (
    <>
      <div className="embed-responsive">
        <iframe
          title="Book Service"
          src="https://docs.google.com/forms/d/e/1FAIpQLSe_CJTvSaQBqt0OQ_Rdq0qvPDuEgU4Grhec7jlqOz982Yb1hA/viewform?embedded=true"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          width="100%"
          height="800px"
          className="embed-responsive-item"
          allow="autoplay 'self'; fullscreen 'self'"
        >
          Loading...
        </iframe>
      </div>
    </>
  );
}
